var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfiguracionAgricola(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4641",
    "data-name": "Rect\\xE1ngulo 4641",
    width: 85,
    height: 85,
    transform: "translate(152 6426)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "configuracion_agricola",
    "data-name": "configuracion agricola",
    transform: "translate(-152 -6426)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10060",
    "data-name": "Grupo 10060",
    transform: "translate(-1501.092 5285.208)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_53",
    "data-name": "L\\xEDnea 53",
    x2: 32,
    transform: "translate(1664 1215)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: "16 16 100"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54",
    "data-name": "L\\xEDnea 54",
    x2: 25,
    transform: "translate(1702 1215)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19266",
    "data-name": "Trazado 19266",
    d: "M1727.184,1373.974c-2.256,0-2.256-1.974-4.513-1.974s-2.256,1.974-4.512,1.974-2.256-1.974-4.512-1.974-2.256,1.974-4.512,1.974-2.257-1.974-4.513-1.974-2.256,1.974-4.512,1.974-2.256-1.974-4.513-1.974-2.256,1.974-4.513,1.974-2.257-1.974-4.513-1.974-2.256,1.974-4.512,1.974-2.257-1.974-4.514-1.974-2.257,1.974-4.514,1.974-2.257-1.974-4.515-1.974-2.257,1.974-4.515,1.974",
    transform: "translate(0 -165.702)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10060-2",
    "data-name": "Grupo 10060",
    transform: "translate(1702.999 1191.49)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_55",
    "data-name": "L\\xEDnea 55",
    y1: 9.58,
    transform: "translate(8.388 6.216)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19267",
    "data-name": "Trazado 19267",
    d: "M1858.1,1314.1c2.313-2.313,6.283-2.094,6.283-2.094s.219,3.97-2.095,6.283-6.283,2.094-6.283,2.094S1855.783,1316.413,1858.1,1314.1Z",
    transform: "translate(-1847.608 -1312)",
    fill: "#95d4e9",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19268",
    "data-name": "Trazado 19268",
    d: "M1824.11,1318.288c-2.313-2.313-2.094-6.283-2.094-6.283s3.97-.219,6.283,2.094,2.094,6.283,2.094,6.283S1826.424,1320.6,1824.11,1318.288Z",
    transform: "translate(-1822.01 -1312)",
    fill: "#95d4e9",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19269",
    "data-name": "Trazado 19269",
    d: "M1664,1155.949v23.694a3.949,3.949,0,0,0,3.949,3.949h13.821v11.847l11.847-11.847h29.617a3.949,3.949,0,0,0,3.949-3.949v-23.694a3.949,3.949,0,0,0-3.949-3.949h-55.286A3.949,3.949,0,0,0,1664,1155.949Z",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10061",
    "data-name": "Grupo 10061",
    transform: "translate(1671.903 1161.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19270",
    "data-name": "Trazado 19270",
    d: "M1743.406,1192l-3.949,3.949-3.949-3.949-11.847,11.847-7.9-7.9-7.9,7.9-3.949-3.949-7.9,7.9",
    transform: "translate(-1696.019 -1192)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19271",
    "data-name": "Trazado 19271",
    d: "M1702.98,1184l-2.962,5.923h5.923Z",
    transform: "translate(-27.129 -24.102)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguracionAgricola);
export default __webpack_public_path__ + "static/media/configuracion-agricola.67717bbd038c719e96baa009de0f9a03.svg";
export { ForwardRef as ReactComponent };